import React from 'react'
import { useLocation } from 'react-router-dom'

function parseQuery(search) {
  try {
    const params = new URLSearchParams(search)
    const guestName = params.get('guestName') || params.get('name') || ''
    const guestRole = params.get('guestRole') || params.get('role') || ''
    return { guestName: guestName ? decodeURIComponent(guestName) : '', guestRole: guestRole ? decodeURIComponent(guestRole) : '' }
  } catch (e) {
    return { guestName: '', guestRole: '' }
  }
}

/**
 * GuestGreeting
 * Props:
 * - guestName, guestRole: override values (strings)
 * - autoDetect: when true (default) will read from URL query params `guestName`/`guestRole` or `name`/`role`
 * - children: custom render. If children is a function it will be called with { guestName, guestRole }
 * - className: optional extra class
 */
export default function GuestGreeting({ guestName: pName, guestRole: pRole, autoDetect = true, children, className = '' }) {
  const location = useLocation()
  let guestName = pName || ''
  let guestRole = pRole || ''

  if (autoDetect && (!guestName && !guestRole)) {
    const parsed = parseQuery(location ? location.search : window.location.search)
    guestName = parsed.guestName || guestName
    guestRole = parsed.guestRole || guestRole
  }

  const has = guestName || guestRole
  if (!has) return null

  const content = (
    <div className={`guest-greeting ${className}`.trim()}>
      <div className="greeting-text">
        {guestName ? <strong className="greeting-name">Hello, {guestName}</strong> : <strong className="greeting-name">Hello</strong>}
        {guestRole ? <span className="greeting-role"> — {guestRole}</span> : null}
      </div>
    </div>
  )

  if (children) {
    if (typeof children === 'function') return children({ guestName, guestRole, defaultRender: content })
    // if children is React node, render it but provide values via cloned element props if possible
    return React.cloneElement(children, { guestName, guestRole, defaultRender: content })
  }

  return content
}
